export default __webpack_public_path__ + "static/media/SideLeaf.729371be.svg";